import {
    COURSE_BADGE_INCLUDED_IN_PLANS,
    COURSE_BADGE_PREMIUM,
    COURSE_BADGE_TOP_PICK,
    CourseBadgeFamily,
} from '@udemy/browse-course';

const badgeFilter = (badge: CourseBadgeFamily) =>
    ![COURSE_BADGE_TOP_PICK, COURSE_BADGE_INCLUDED_IN_PLANS].includes(badge);

export const browseCourseContextProps = {
    browseBadgeHandlerOptions: {
        numberOfBadgesToShow: 2,
        filter: badgeFilter,
        priority: {[COURSE_BADGE_PREMIUM]: Number.MAX_SAFE_INTEGER},
    },
};

export const minimalBrowseCourseContextProps = {
    browseBadgeHandlerOptions: {
        filter: badgeFilter,
    },
};
